import type { IFrontendServiceContainer } from '@phi/frontend/service-container';
import styles from './index.module.scss';
import { type PropType, defineComponent, h } from 'vue';
import { PopUnder } from '@phi/components';
import { Route, VueRouter } from '@phi/vue-router';
import { RegisterPage } from '@phi/authentication/frontend';
import { set } from '@phi/util/vuetils';

export const PopUnderWithRouter = defineComponent({
    props: {
        app: { required: true, type: Object as PropType<IFrontendServiceContainer> },
    },

    setup(props) {
        const app = props.app;
        const service = app.pop_under_with_router;

        if (!service.state.route.value)
            service.state.route.value = (route: Route) => h(RegisterPage, { app, route });

        if (service.state.pop_under_white.value) {
            console.log('Showing popunder white');
            return () => h(PopUnder, {
                class: styles.popunder_white,
                hidden: !service.state.showing_pop_under.value,
            }, () => h(VueRouter, {
                route: service.state.route.value,
                'onUpdate:route': set(service.state.route),
            }));
        } else {
            console.log('Showing popunder black');
            return () => h(PopUnder, {
                class: styles.popunder,
                hidden: !service.state.showing_pop_under.value,
            }, () => h(VueRouter, {
                route: service.state.route.value,
                'onUpdate:route': set(service.state.route),
            }));
        }
    },
});
